import { useEffect, useState } from 'react';
import { bindActionCreators } from '@reduxjs/toolkit';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Button from 'carbon-react/lib/components/button';
import Preview from 'carbon-react/lib/components/preview';

import Translate from '../../components/Translate/Translate';

import * as user from '../../redux/User/actions';

const VerifyEmail = ({ history, location, user, verifyUser }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    verifyUser({ confirmationToken: location.search.split('confirmationToken=')[1] });
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading || user.saving || user.loading)
    return (
      <div className="register">
        <Preview loading height="700px" width="450px" />
      </div>
    );

  if (user.error)
    return (
      <div className="register" style={{ flexDirection: 'column' }}>
        <p>
          <Translate scope="auth.InviteError" />
        </p>
        <p>{JSON.stringify(user.error.message)}</p>
      </div>
    );

  return (
    <div className="register" style={{ display: 'flex', flexDirection: 'column' }}>
      <Translate scope="verify.SuccessMessage" style={{ marginBottom: 20 }} />
      <Button onClick={() => history.push('/timesheets')}>
        <Translate scope="verify.Login" />
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => {
  const _user = bindActionCreators(user, dispatch);
  return {
    verifyUser: _user.verifyUserRequest,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VerifyEmail));
